<template>
  <footer class="app-footer">
    <div class="container">
      <div class="app-footer__lead">
        <p class="mono">Engineer · Architect · Builder</p>
        <p>Good systems make the complex feel considered.</p>
      </div>

      <div class="app-footer__bar">
        <div>
          <strong>Markus Olsson</strong>
          <span>© {{ year }} · Malmö, Sweden</span>
        </div>

        <nav class="app-footer__links" aria-label="Footer navigation">
          <a
            href="https://github.com/FeodalherreN"
            target="_blank"
            rel="noopener"
          >
            GitHub <span aria-hidden="true">↗</span>
          </a>
          <a
            href="https://github.com/FeodalherreN/markusolsson.com"
            target="_blank"
            rel="noopener"
          >
            Site source <span aria-hidden="true">↗</span>
          </a>
          <a
            href="https://playulna.com/"
            target="_blank"
            rel="noopener"
          >
            Play Ulna <span aria-hidden="true">↗</span>
          </a>
          <a href="#top">Back to top <span aria-hidden="true">↑</span></a>
        </nav>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return { year: new Date().getFullYear() };
  },
};
</script>

<style lang="scss" scoped>
.app-footer {
  padding: clamp(72px, 10vw, 128px) 0 34px;
}

.app-footer__lead {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: clamp(34px, 8vw, 108px);
  align-items: start;
  padding: 0 0 clamp(58px, 8vw, 94px);
}

.app-footer__lead p:first-child {
  margin: 9px 0 0;
  color: var(--accent);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.11em;
  text-transform: uppercase;
}

.app-footer__lead p:last-child {
  max-width: 19ch;
  margin: 0;
  color: var(--text);
  font-size: clamp(32px, 5.5vw, 68px);
  font-weight: 650;
  letter-spacing: -0.055em;
  line-height: 1.03;
}

.app-footer__bar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-6);
  padding-top: var(--space-5);
  border-top: 1px solid var(--border-strong);
}

.app-footer__bar > div {
  display: grid;
  gap: 3px;
}

.app-footer__bar strong {
  color: var(--text);
  font-size: 12px;
  font-weight: 680;
}

.app-footer__bar > div span {
  color: var(--muted);
  font-size: 10px;
}

.app-footer__links {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px 24px;
}

.app-footer__links a {
  color: var(--muted);
  font-size: 11px;
  font-weight: 620;
}

.app-footer__links a:hover {
  color: var(--accent-strong);
  text-decoration: none;
}

@media (max-width: 700px) {
  .app-footer__lead {
    grid-template-columns: 1fr;
    gap: var(--space-5);
  }

  .app-footer__bar {
    align-items: flex-start;
    flex-direction: column;
  }

  .app-footer__links {
    justify-content: flex-start;
  }
}
</style>
